// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__TVCkx","containerItemsCenter":"Skeleton_containerItemsCenter__3paOI"};